<template>
  <div class="modal-overlay">
    <div class="mmodal-content" style="max-width: 90vw">
      <div class="modal-header">
        <h5 class="modal-title">Create Appointment</h5>
        <button type="button" class="close" @click="closeModal">&times;</button>
      </div>
      <div class="modal-body">
        <form v-if="loading == false">
          <div class="row">
            <div class="form-group col-md-6">
              <label for="inputEmail4">Patient Name</label>
              <!-- <input type="text" name="item_name" v-on:keyup="handleKeyUp" class="form-control" id="inputEmail4" placeholder="item name"> -->
              <PatientInput @patientoption-check="get_patient" />
            </div>
            <div class="form-group col-md-4">
              <!-- <label for="inputPassword4">DOB / Age</label> -->

              <!--  -->
              <div class="form-check form-check-inline">
                <input
                  v-model="selecteddobOption"
                  class="form-check-input"
                  type="radio"
                  name="dob_age"
                  value="dob"
                  checked
                />
                <label class="form-check-label" for="inlineRadio1">DOB /</label>
              </div>
              <div class="form-check form-check-inline">
                <input
                  v-model="selecteddobOption"
                  class="form-check-input"
                  type="radio"
                  name="dob_age"
                  value="age"
                />
                <label class="form-check-label" for="inlineRadio2">AGE</label>
              </div>

              <!--  -->

              <input
                v-if="selecteddobOption == 'dob'"
                @change="change_input"
                type="date"
                name="dob"
                class="form-control"
                :value="this.dob"
                placeholder="date of birth"
              />
              <input
                v-if="selecteddobOption == 'age'"
                v-on:keyup="change_input"
                type="number"
                name="age"
                class="form-control"
                :value="this.age"
                placeholder="age"
              />
            </div>

            <div class="form-group col-md-2">
              <label for="inputPassword4">Gender</label>
              <select @change="change_input" class="form-control" name="gender">
                <option value="">Choose...</option>
                <option
                  v-for="gen in genders"
                  :value="gen.id"
                  :key="gen.id"
                  :selected="gen.id == gender"
                >
                  {{ gen.name }}
                </option>
              </select>
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-4">
              <label for="item_category_id">Residence</label>
              <input
                type="text"
                name="residence"
                @change="change_input"
                class="form-control"
                :value="residence"
                placeholder="residence"
              />
            </div>

            <div class="form-group col-md-3">
              <label for="item_class_id">ID/Passport No.</label>
              <input
                type="text"
                name="passport"
                @change="change_input"
                class="form-control"
                :value="passport"
                placeholder="ID/passport"
              />
            </div>

            <div class="form-group col-md-3">
              <label for="item_class_id">Phone No.</label>
              <input
                type="number"
                name="phone"
                @change="change_input"
                class="form-control"
                :value="phone"
                placeholder="phone"
              />
            </div>

            <div class="form-group col-md-2">
              <label for="item_class_id">OPD</label>
              <input
                type="text"
                name="opd"
                @change="change_input"
                class="form-control"
                :value="opd"
                placeholder="opd"
              />
            </div>
          </div>

          <div class="row">
            <div class="form-group col-md-4">
              <label for="item_category_id">Email</label>
              <input
                type="text"
                name="email"
                @change="change_input"
                class="form-control"
              />
            </div>

            <div class="form-group col-md-4">
              <label for="clinic_id">Clinic / Speciality</label>
              <select @change="change_input" class="form-control" name="clinic">
                <option value="">Choose...</option>
                <option
                  v-for="clinic in clinics"
                  :value="clinic.id"
                  :key="clinic.id"
                >
                  {{ clinic.clinic_name }}
                </option>
              </select>
            </div>
            <div class="form-group col-md-4">
              <label for="item_category_id"
                >Complaints / Symptom/ Illness</label
              >
              <textarea
                name="complaints"
                @change="change_input"
                class="form-control"
                :value="complaints"
                placeholder="complaints"
              ></textarea>
            </div>
          </div>

          <div class="dot_line"></div>
          <div style="margintop: 1px" class="dot_line"></div>
          <div style="backgroundcolor: beige; height: 3em">
            <button
              @click="add_column"
              style="fontsize: 1.5em"
              class="righter mycustom-success-button"
              type="button"
            >
              +
            </button>
          </div>

          <table class="table">
            <!-- <caption>Create Multiple Appointments</caption> -->
            <thead>
              <tr>
                <th width="40%" scope="col">Appointment Date-Time</th>
                <th width="25%" scope="col">Doctor / Practitioner</th>
                <th width="30%" scope="col">Note</th>
                <th width="5%" scope="col">Remove</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="data in appointment_data" :key="data.gen_id">
                <th scope="row">
                  <input
                    type="datetime-local"
                    name="date"
                    v-on:change="handleAppointmentDataChange(data.gen_id)"
                    class="form-control"
                  />
                </th>
                <td>
                  <input
                    type="text"
                    name="doc"
                    v-on:keyup="handleAppointmentDataChange(data.gen_id)"
                    class="form-control"
                  />
                </td>
                <td>
                  <input
                    type="text"
                    name="note"
                    v-on:keyup="handleAppointmentDataChange(data.gen_id)"
                    class="form-control"
                  />
                </td>
                <td>
                  <button @click="remove_column(data.gen_id)" type="button">
                    --
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <button @click="submitHandler" class="btn btn-primary righter">
            Submit
          </button>
        </form>

        <div class="loader-style" v-if="loading == true">Loading...</div>
      </div>
    </div>
  </div>
</template>

<script>
import { generalApiRequest } from "../../../api/apiIndex";
import PatientInput from "../../Patients/components/patient_input.vue";
export default {
  name: "ModalContent",
  data() {
    return {
      loading: false,
      patient_name: "",
      patient_id: "",
      age: "",
      dob: "",
      selecteddobOption: "dob",
      dob_type: true,
      dob_age: "dob",
      gender: "",
      genders: [],
      clinics: [],
      clinic: "",
      opd: "",
      phone: "",
      passport: "",
      residence: "",
      email: "",
      complaints: "",
      // citizen_id:"",
      appointment_data: [{ date: "", doc: "", note: "", gen_id: "1" }],
    };
  },
  components: {
    PatientInput,
  },
  methods: {
    closeModal() {
      this.$emit("close");
    },
    saveModal() {
      this.$emit("save");
    },

    async submitHandler(event) {
      event.preventDefault();
      this.apiLoading = true;
      this.loading = true;
      const url = "create_appointment";
      const body = {
        patient_name: this.patient_name,
        patient_id: this.patient_id,
        age: this.age,
        dob: this.dob,
        dob_age: this.dob_age,
        gender: this.gender,
        opd: this.opd,
        phone: this.phone,
        passport: this.passport,
        residence: this.residence,
        email: this.email,
        clinic: this.clinic,
        appointment_data: this.appointment_data,
      };

      const resp = await generalApiRequest(url, "POST", body, 1);
      //console.log(rs);
      // console.log(body);
      if (resp) {
        this.apiLoading = false;
        this.loading = false;
        this.$emit("close");
        // this.$emit('reload-content');
        window.location.reload();
      }
    },

    get_patient(option) {
      console.log(option);
      console.log(this.genders);
      this.patient_name = option.name;
      this.patient_id = option.id;
      this.dob = option.dob;
      this.dob_age = "dob";
      this.gender = option.gender;
      this.opd = option.opd;
      this.phone = option.phone;
      this.passport = option.id_number;
      this.residence = option.location;
    },

    change_input(e) {
      this[e.target.name] = e.target.value;
      if (e.target.name == "age") {
        // console.log( this.calculateDateOfBirth(e.target.value) );
        this.dob = this.calculateDateOfBirth(e.target.value);
      }

      const body = {
        patient_name: this.patient_name,
        patient_id: this.patient_id,
        age: this.age,
        dob: this.dob,
        dob_age: this.dob_age,
        gender: this.gender,
        opd: this.opd,
        phone: this.phone,
        passport: this.passport,
        residence: this.residence,
        email: this.email,
        clinic: this.clinic,
        appointment_data: this.appointment_data,
      };

      console.log(body);
    },

    calculateDateOfBirth(age) {
      if (isNaN(age) || age < 0) {
        return null; // Handle invalid age
      }

      const today = new Date();
      const birthYear = today.getFullYear() - age;
      const birthDate = new Date(birthYear, today.getMonth(), today.getDate());

      return birthDate.toISOString().slice(0, 10); // Extract YYYY-MM-DD format
    },

    getRandomInt(min, max) {
      min = Math.ceil(min);
      max = Math.floor(max);
      return Math.floor(Math.random() * (max - min)) + min;
    },

    add_column() {
      var gen_id = this.getRandomInt(2, 9000);
      // console.log(this.rows);
      var newRow = { date: "", doc: "", clinic: "", gen_id: gen_id };
      this.appointment_data = [...this.appointment_data, newRow];
    },

    remove_column(identifier) {
      for (let i = 0; i < this.appointment_data.length; i++) {
        if (this.appointment_data[i].gen_id === identifier) {
          this.appointment_data.splice(i, 1);
          return; // Exit the loop after finding and removing
        }
      }
      console.warn(`Row with ID "${identifier}" not found.`);
    },

    async genders_get() {
      const url = "genders_get";
      const body = {};
      const res = await generalApiRequest(url, "GET", body, 1);
      // console.log(clas);
      this.genders = res;
    },

    async clinics_get() {
      const url = "get_all_clinics";
      const body = {};
      const res = await generalApiRequest(url, "GET", body, 1);
      //    console.log(res);
      this.clinics = res;
    },

    // onchangeHandler(e){
    //     console.log(e.target.value);

    // },
    handleKeyUp(e) {
      this[e.target.name] = e.target.value;
      // console.log(e.target.value);
      // console.log(e.target.name);
    },

    handleAppointmentDataChange(gen_id) {
      var state_object = this.appointment_data;

      for (let i = 0; i < state_object.length; i++) {
        if (state_object[i].gen_id === gen_id) {
          state_object[i][event.target.name] = event.target.value;
          this.appointment_data = state_object;
        }
      }
    },
  },

  mounted() {
    this.genders_get();
    this.clinics_get();
  },
};
</script>

<style scoped>
.modal-body {
  padding: 1rem;
  overflow-y: auto; /* Scrollable content */
  flex-grow: 1; /* Allow the body to grow and take available space */
}

.modal-footer {
  border-top: 1px solid #ddd;
  display: flex;
  justify-content: flex-end;
}

.patient-profile {
  margin: 0;
}

.close {
  background: rgb(233, 22, 22);
  border: 1px solid rgb(182, 178, 178);
  font-size: 1.5rem;
  color: white;
  line-height: 1;
  cursor: pointer;
}
.loader-style {
  display: flex;
  justify-content: center;
  font-weight: bold;
  color: black;
  font-size: 2em;
}

/*  */
</style>
